class qtyPicker extends HTMLElement {
  constructor() {
    super();

    this.plusBtn = null;
    this.minusBtn = null;
    this.iconRemove = null;
    this.iconMinus = null;
    this.valueInput = null;
    this.pickerContainer = null;
    this.relatedProductHandle = null;
    this._unsubQuantity = null;
  }

  connectedCallback() {
    console_log('Qty picker connected');
    this.ctaBtn = this.querySelector('button.cta');
    this.pickerContainer = this.querySelector('.picker__container');
    this.plusBtn = this.pickerContainer.querySelector('button[name="plus"]');
    this.minusBtn = this.pickerContainer.querySelector('button[name="minus"]');
    this.iconRemove = this.minusBtn?.querySelector('.icon-remove') ?? null;
    this.iconMinus = this.minusBtn?.querySelector('.icon-minus') ?? null;
    this.valueInput = this.querySelector('input');
    this.relatedProductHandle = this.dataset.relatedProductHandle;

    this.ctaBtn.addEventListener('click', this.plus.bind(this));
    this.plusBtn.addEventListener('click', this.plus.bind(this));
    this.minusBtn.addEventListener('click', this.minus.bind(this));
    this.valueInput.addEventListener('input', this.valueChange.bind(this));

    // Keep in sync when another component (e.g. the slider) removes a unit
    this._unsubQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, (state) => this._syncFromState(state));

    this._updateMinusIcons(parseInt(this.valueInput.value));
  }

  disconnectedCallback() {
    this._unsubQuantity?.();
  }

  plus() {
    const storage = window.mmStorage;
    if (storage.totalQuantity < storage.config.max_products) {
      this.valueInput.value = parseInt(this.valueInput.value) + 1;
      this.valueInput.dispatchEvent(new Event('input', { bubbles: true }));

      if (!this.pickerContainer.classList.contains('active')) {
        this.pickerContainer.classList.add('active');
        this.ctaBtn.classList.add('hidden');
      }

      this._updateMinusIcons(parseInt(this.valueInput.value));
    } else {
      this.closest('mix-match')?.showLimitAlert?.();
    }
  }

  minus() {
    console_log('Minus button clicked');
    if (parseInt(this.valueInput.value) > 0) {
      this.valueInput.value = parseInt(this.valueInput.value) - 1;
      this.valueInput.dispatchEvent(new Event('input', { bubbles: true }));

      if (this.valueInput.value === '0') {
        this.pickerContainer.classList.remove('active');
        this.ctaBtn.classList.remove('hidden');
      }

      this._updateMinusIcons(parseInt(this.valueInput.value));
    }
  }

  valueChange() {
    console_log('Value changed');
    this._updateMinusIcons(parseInt(this.valueInput.value));
    window.mmStorage.setProductQuantity(this.relatedProductHandle, this.valueInput.value);
  }

  // Called via quantityUpdate subscription — keeps display in sync with storage truth.
  // Setting .value directly does NOT fire the 'input' event, so no feedback loop.
  _syncFromState(state) {
    const product = state.products.find(p => p.handle === this.relatedProductHandle);
    const qty = product ? product.quantity : 0;

    this.valueInput.value = qty;

    if (qty > 0) {
      this.pickerContainer.classList.add('active');
      this.ctaBtn.classList.add('hidden');
    } else {
      this.pickerContainer.classList.remove('active');
      this.ctaBtn.classList.remove('hidden');
    }

    this._updateMinusIcons(qty);
  }

  // qty === 1 → trash (remove line). qty > 1 → minus (decrement only visually).
  _updateMinusIcons(qty) {
    if (!this.iconRemove || !this.iconMinus) return;

    if (qty > 1) {
      this.iconRemove.classList.add('hidden');
      this.iconMinus.classList.remove('hidden');
    } else {
      this.iconRemove.classList.remove('hidden');
      this.iconMinus.classList.add('hidden');
    }
  }
}

if (!customElements.get('qty-picker')) {
  customElements.define('qty-picker', qtyPicker);
}
